// extracted by mini-css-extract-plugin
export default {"socialLogins":"wFZnX"};